import {
  ConversationMessageType,
  ConversationMessage,
  Message,
} from '@marketplace-web/messaging/conversation-messaging-data'

function isTextMessage(currentMessage: ConversationMessage) {
  return (
    currentMessage.entityType === ConversationMessageType.Message ||
    currentMessage.entityType === ConversationMessageType.PortalMessage
  )
}

function isMessageAuthorTheSame(
  currentMessage: ConversationMessage,
  previousMessage: ConversationMessage,
) {
  const currentEntity = currentMessage.message as Message
  const previousEntity = previousMessage.message as Message

  if (!currentEntity || !previousEntity) return false

  return `${currentEntity.userId}` === `${previousEntity.userId}`
}

function isSequenceOfTextMessages(
  currentMessage: ConversationMessage,
  previousMessage: ConversationMessage,
) {
  return isTextMessage(currentMessage) && isTextMessage(previousMessage)
}

function isMessageGrouped(
  currentMessage?: ConversationMessage | null,
  previousMessage?: ConversationMessage | null,
) {
  if (!currentMessage || !previousMessage) return false
  if (!isMessageAuthorTheSame(currentMessage, previousMessage)) return false

  return isSequenceOfTextMessages(currentMessage, previousMessage)
}

export { isMessageGrouped }
